document.addEventListener('DOMContentLoaded', function () {
  init();
});

const init = () => {
  let filterButtons = document.querySelectorAll('.storyList .filter-button');

  filterButtons.forEach((filterButton) => {
    filterButton.addEventListener('click', (event) => {
      setActiveButton(filterButtons, event);
      filterBlocks(event);
    });
  });

    if (window.location.hash) {
        window.scrollTo(0, 0);

        [...filterButtons].find((filterButton) => {
            if (filterButton.id === window.location.hash.replace('#', '')) {
                filterButton.children[0].click();
            }
        });
    }
};

const setActiveButton = (filterButtons, event) => {
  filterButtons.forEach((filterButton) => {
    filterButton.classList.remove('active');
    filterButton.setAttribute('aria-pressed', 'false');
  });

    // currentTarget, not target.parentElement: keyboard activation fires the click on the
    // button itself, whose parent is the container div.
    event.currentTarget.classList.add('active');
    event.currentTarget.setAttribute('aria-pressed', 'true');

    if (event.currentTarget.id !== 'all')
        window.history.replaceState(undefined, undefined, `#${event.currentTarget.id}`)
    else
        window.history.replaceState(undefined, undefined, ' ')
};

const filterBlocks = (event) => {
  var filterId = event.currentTarget.id;

  let blocks = document.querySelectorAll('.story-content-block');

  blocks.forEach((block) => {
    block.classList.remove('d-none');

    if (filterId === 'all') return;

    if (block.dataset.tagId !== filterId) block.classList.add('d-none');
  });
};
